<template>
  <div class="te1">
		<div class="te11">是否选择发送短信</div>
		<div class="te12">
			<div @click="issms(1)" :class="[{'te1212':is_sms==1},'te121']">是</div>
			<div @click="issms(2)" :class="[{'te1212':is_sms==2},'te121']">否</div>
		</div>
	</div>
</template>

<script>

  export default {
    data() {
      return {
        is_sms:1,
      }
    },
    created() {},
    mounted() {
			
    },
    activated() {
    },
    methods: {
      issms(e){
				this.is_sms=e
			}
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .te1{
		width:100%;
		padding: 32*@vm_base;
		display: flex;
		justify-content: space-between;
		align-items:center;
		
		color: #333333;
		font-size: 28*@vm_base;
		
	}
	.te12{
		display: flex;
		justify-content: space-between;
		align-items:center;
	}
	.te121{
		padding: 6*@vm_base 24*@vm_base;
		margin-left: 12*@vm_base;
		border: 1*@vm_base solid #999;
		border-radius: 12*@vm_base;
	}
	.te1212{
		border: 1*@vm_base solid rgb(247, 181, 0);
		color: rgb(247, 181, 0);
	}
</style>



// WEBPACK FOOTER //
// src/components/unpublic/agent/te.vue